export default "__VITE_ASSET__cf0ff0cb__"